import type {
  ISignUpRequestBody,
  ISignUpResponseBody,
} from "~/feature/auth/type";
import { api } from "~/store/api";

const API_PREFIX = "/email";

const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    submitEmail: builder.mutation<ISignUpResponseBody, ISignUpRequestBody>({
      query: (data) => ({
        url: API_PREFIX,
        method: "POST",
        body: data,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useSubmitEmailMutation } = authApi;
